<template>
  <el-dialog
    title="职务成员信息"
    :visible.sync="show"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
    width="40%"
  >
    <div class="dialog_box">
      <el-table :data="tableData" height="500px" class="dialog_table_box">
        <el-table-column label="序号" width="70" align="center" type="index">
        </el-table-column>
        <el-table-column prop="userName" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="departmentName" label="部门" align="center">
        </el-table-column>
        <el-table-column prop="userPhone" label="电话" align="center">
        </el-table-column>
        <el-table-column prop="addtime" label="创建时间" align="center">
          <template slot-scope="rowData">
            {{ $Common.dateFormatDate(rowData.row.addtime) }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          column-key="index"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <div class="text-center">
              <el-button
                type="danger"
                size="mini"
                plain
                icon="el-icon-circle-close"
                @click="delDataInfo(scope.row.id)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    jobId: {
      type: String
    }
  },
  data() {
    //这里存放数据
    return {
      show: false,
      tableData: [],
      total: 0
    };
  },
  //监控data中的数据变化
  watch: {
    showDialog: function(val) {
      this.show = val;
      if (val) {
        this.getDataList();
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    // 获取数据列表
    async getDataList() {
      let requestData = {
        id: this.jobId
      };
      let res = await this.$Http.getSchoolJobDetails(requestData, true);
      if (res.code == 200) {
        this.tableData = res.data || [];
      } else if (res.code == 101) {
        this.tableData = [];
      } else {
        this.tableData = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    handleClose() {
      this.$emit("close");
    },
    delDataInfo(thisId) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = [thisId];
          let res = await this.$Http.delSchoolJobMember(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss"></style>
